(function (ws) {
    'use strict';
    ws.views.telstrainboundpage = ws.views.simpleTable.extend({

        /**
         * Events override
         */
        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'change input.inputfile': 'showUploadedFile',
            'click .push-file': 'uploadFile',
            'click .search-button': 'searchInboundRequest',
            'click .send-request': 'retriggerFreshdeskTicket',
            'keyup .search-sku-input': 'enableButton',
            'click .select-account': 'enableSendButton'
        }),

        /**
         * Initialize override
         */
        initialize: function () {
            this.$table = this.$('#telstra-inbound-table');
            ws.views.simpleTable.prototype.initialize.call(this);
            this.$table.hide();
            this.$pushFile = this.$('.push-file');
            this.$uploadedFile = this.$('.file-upload span');
            this.$modalMessage = $('#telstraInboundUploadModal');
            this.trilliumSearch();
            $('.dataTables_info').hide();
            $('.pagination').hide();

            this.$('select').select2({
                minimumResultsForSearch: -1
            });
        },

        showUploadedFile: function (e) {
            if (e.currentTarget.files[0]) {
                this.$uploadedFile.text(e.currentTarget.files[0].name);
                this.$pushFile.attr('disabled', false);
            } else {
                this.$uploadedFile.text('');
                this.$pushFile.attr('disabled', true);
            }
        },

        uploadFile: function () {
            let url = globals.path.api.westcon.telestraInboundFIleUpload + '?' + CSRF;
            let myFormData = new FormData();
            if (this.$('.inputfile')[0].files[0]) {
                myFormData.append('file', $('.inputfile')[0].files[0]);
                globals.disableApp();
                $.ajax({
                    url: url,
                    enctype: 'multipart/form-data',
                    type: 'POST',
                    data: myFormData,
                    processData: false,
                    contentType: false,
                    success:function(res) {
                        this.$uploadedFile.text('');
                        this.$pushFile.attr('disabled', true);
                        this.$('.inputfile').replaceWith(this.$('.inputfile').val('').clone(true));
                        globals.enableApp();
                        this.$modalMessage.find('p').html('');
                        this.$modalMessage.find('span').html('');
                        if (res.error) {
                            this.eventAgg.trigger('telstraInboundUploadModal');
                            if (res.errorMessage === 'Duplicate NCP and NCO values') {
                                this.$modalMessage.find('p').html('Telstra BSS inbound request has already been received. Please use the search functionality to send the XML to create a request in 1View and FreshDesk');
                            } else {
                                this.$modalMessage.find('p').html('The BSS telstra inbound request uploaded is invalid due to the following errors').css('color', 'red');
                                this.$modalMessage.find('span').html('The failure reasons are:<br />' + res.errorMessage).css('color', 'red');
                            }
                        } else {
                            this.eventAgg.trigger('telstraInboundUploadModal');
                            this.$modalMessage.find('p').html('BSS request has been successfully sent to FreshDesk').css('color', '#666');
                            if (res.poNumber) {
                                this.$modalMessage.find('span').html('The PO Number generated is:' + res.poNumber).css('color', '#666');
                            } else if (res.rfqId) {
                                this.$modalMessage.find('span').html('The RFQ Number generated is:' + res.rfqId).css('color', '#666');
                            }
                        }
                    }.bind(this),
                    error: function () {
                        this.$uploadedFile.text('');
                        this.$pushFile.attr('disabled', true);
                        this.$('.inputfile').replaceWith(this.$('.inputfile').val('').clone(true));
                        this.$modalMessage.find('p').html('');
                        this.$modalMessage.find('p').html('Something went wrong');
                        this.$modalMessage.find('span').html('');
                        globals.enableApp();
                        console.log('ERROR');
                    }.bind(this)
                });
            } else {
                console.log('no file found');
            }
        },

        enableButton: function (ev) {
            if (ev.which === 13) {
                this.searchInboundRequest();
            }

            if (this.$('.search-sku-input').val()) {
                this.$('.search-button').attr('disabled', false);
            } else {
                this.$('.search-button').attr('disabled', true);
            }
        },

        enableSendButton: function (ev) {
            if (this.$('.select-account:checked').length) {
                this.$('.send-request').attr('disabled', false);
            } else {
                this.$('.send-request').attr('disabled', true);
            }
        },

        searchInboundRequest: function () {
            if (this.$('.search-sku-input').val()) {
                let url = globals.path.api.westcon.getBssOrderData + '?key=' + this.$('.search-sku-select').val() + '&value=' + this.$('.search-sku-input').val();

                globals.disableApp();
                $.ajax({
                    url: url,
                    type: 'GET',
                    success: function (res) {
                        globals.enableApp();
                        this.trilliumSearch(res);
                        if (res) {
                            this.$('.send-request').show().attr('disabled', true);
                            $('.dataTables_info').show();
                            $('.pagination').show();
                        } else {
                            this.$('.send-request').hide();
                            $('.dataTables_info').hide();
                            $('.pagination').hide();
                        }
                    }.bind(this),
                    error: function () {
                        globals.enableApp();
                        console.log('ERROR');
                        this.$('.send-request').hide();
                        $('.dataTables_info').hide();
                        $('.pagination').hide();
                        this.trilliumSearch();
                    }.bind(this)
                });
            }
        },

        retriggerFreshdeskTicket: function () {
            let url = globals.path.api.westcon.retriggerFreshdeskTicket + '?' + CSRF;
            let myFormData = new FormData();
            myFormData.append('ncpNcoValue', this.$('.select-account:checked').data('ncp') + this.$('.select-account:checked').data('nco'));

            globals.disableApp();
            $.ajax({
                url: url,
                type: 'POST',
                data: myFormData,
                processData: false,
                contentType: false,
                success: function (res) {
                    this.$modalMessage.find('p').html('');
                    this.$modalMessage.find('span').html('');
                    globals.enableApp();
                    if (!res.error) {
                        this.eventAgg.trigger('telstraInboundUploadModal');
                        this.$modalMessage.find('p').html('BSS request has been successfully sent to FreshDesk').css('color', '#666');
                        if (res.poNumber) {
                            this.$modalMessage.find('span').html('The PO Number generated is:' + res.poNumber).css('color', '#666');
                        } else if (res.rfqId) {
                            this.$modalMessage.find('span').html('The RFQ Number generated is:' + res.rfqId).css('color', '#666');
                        }
                    } else {
                        this.eventAgg.trigger('telstraInboundUploadModal');
                        this.$modalMessage.find('p').html('The FreshDesk ticket creation is failed due to the following error').css('color', 'red');
                        this.$modalMessage.find('span').html(res.errorMessage).css('color', 'red');
                    }
                }.bind(this),
                error: function () {
                    this.$modalMessage.find('p').html('');
                    this.$modalMessage.find('span').html('');
                    globals.enableApp();
                    console.log('ERROR');
                }.bind(this)
            });
        },

        trilliumSearch: function (response) {
            this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();
            this.$table.hide();
            this.$table.show();
            this.$table.dataTable({
                lengthChange: false,
                searching: false,
                responsive: true,
                aaData: response,
                aoColumns: [
                    { mData: null,
                        mRender: function (data, type, full) {
                            return '<input type="radio" class="select-account" name="select-account" data-ncp=\'' + full.ncp  + '\' data-nco=\'' + full.nco  + '\' />';
                        }
                    },
                    { mData: null,
                        mRender: function (data, type, full) {
                            return '<span/>';
                        }
                    },
                    { mData: 'ncp' },
                    { mData: 'nco' },
                    { mData: 'fnn' },
                    { mData: 'poNumber' },
                    { mData:  null,
                        mRender: function (data, type, full) {
                            return parseInt(full.rfqId) ? '<a  href=\'' + sitePath + '/rfqDetails/display/' + full.rfqId + '?forceDisplay=true' + '\'>' + (full.rfqId ? full.rfqId : '')  + '</a>' : full.rfqId ;
                        }
                    },
                    { mData: null,
                        mRender: function (data, type, full) {
                            return parseInt(full.quoteId) ? '<a  href=\'' + sitePath + '/quoteDetail/display/' + full.quoteId + '?forceDisplay=true' + '\'>' + (full.quoteId ? full.quoteId : '') + '</a>' : full.quoteId;
                        }
                    },
                    { mData: null,
                        mRender: function (data, type, full) {
                            return parseInt(full.sapOrderNumber) ? '<a  href=\'' + sitePath + '/orderDetail/sidDetails/' + full.sapOrderNumber  + '/0' + '?forceDisplay=true' + '\'>' + (full.sapOrderNumber ? full.sapOrderNumber : '') + '</a>' : full.sapOrderNumber;
                        }
                    },
                    { mData: null,
                        mRender: function (data, type, full) {
                            return moment(full.createdDate).format(dateFormat);
                        }
                    },
                    { mData: null,
                        mRender: function (data, type, full) {
                            return '<a download=\'' + full.ncp + full.nco  + '.xml' + '\' href=\'' + sitePath + '/bssTelstraRequest/generateTelstraXml?ncpNcoValue=' + full.ncp + full.nco + '\'>XML Message</a>';
                        }
                    }
                 ]
            });
        }
    });
})(westcon);
